import { NgModule } from '@angular/core';
import { TextareaAutosizeDirective } from './autosize.directive';

@NgModule({
  declarations: [ TextareaAutosizeDirective ],
  exports: [ TextareaAutosizeDirective ]
})
export class AutosizeModule {
}
